import { render, staticRenderFns } from "./RetailItemFilter.vue?vue&type=template&id=08b053ee&"
import script from "./RetailItemFilter.vue?vue&type=script&lang=js&"
export * from "./RetailItemFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports